import React, { Component } from "react";
import axios from "axios";
import Header4 from "../../Header/Header4";
import "./style.css";
import { Radio, Table, Pagination, Button, message } from "antd";
import { connect } from "react-redux";
import { removeCart } from "../GeovisResource/service/actoin.js";
import PayModal from "../GeovisResource/components/payDownLoad/payModal";
import Iframe from "../Iframe/index";

class Chronicles extends Component {
  state = {
    shopType: "base",
    shopData: [],
    spinning: false,
    total: 0,
    selectedRowKeys: [],
    selectedRows: [],
    payModalVisible: false,
    orderList: [],
    totalScore: 0,
  };

  componentDidMount() {
    if (this.props.user.userId) this.initShopData();
  }

  componentDidUpdate(preProps) {
    if (preProps.user.userId !== this.props.user.userId) {
      this.initShopData();
    }
  }

  initShopData = () => {
    this.setState({ spinning: true }, async () => {
      await axios({
        url: global.url.order + "/shop/myshop",
        method: "get",
        params: {
          userId: this.props.user.userId,
          page: this.state.page,
          limit: 9999,
        },
      })
        .then((res) => {
          let data = res.data.payload;
          this.setState({
            shopData: data.records,
            total: data.total,
          });
        })
        .catch((e) => {
          message.error("获取数据失败");
        })
        .finally(() => {
          this.setState({ spinning: false });
        });
    });
  };

  changeType = (e) => {
    this.setState(
      {
        shopType: e.target.value,
      },
      () => {
        if (this.state.shopType === "base") {
          this.initShopData();
        }
      }
    );
  };

  changeCurrentPage = (page) => {
    this.setState({
      page,
    });
  };

  changePageSize = (page, pageSize) => {
    this.setState({
      pageSize,
    });
  };

  onSelectChange = (selectedRowKeys, selectedRows) => {
    console.log("selectedRowKeys changed: ", selectedRowKeys, selectedRows);
    this.setState({ selectedRowKeys, selectedRows });
  };

  handleRemove = async (data) => {
    let delFlag;
    try {
      delFlag = await removeCart(this.state.shopData, data);
      if (delFlag) { 
        message.success('删除成功')
        this.initShopData();
      }
      else message.error("删除失败");
    } catch (error) {}
  };

  handleRemoveAll = async (data) => {
    console.log(data)
    let url = global.url.order + '/shop/delete?'
    data.forEach((item,i)=>{
      if(i == data.length-1) {
        url += 'ids=' + item.shopId
      } else {
        url += 'ids=' + item.shopId + '&'
      }
    })
    console.log(url)
    await axios({
        url,
        method: 'delete',
    }).then(res=>{
      message.success('删除成功')
      this.initShopData()
    }).catch(error=>{
      message.error('删除失败')
    })
  };

  handleDownLoad = async (data) => {
    let indexSocre = 0;
    if (data instanceof Array) {
      console.log("openPayModal-----list", data);
      data.map((value, index) => {
        console.log(value.score);
        indexSocre += value.score;
        // indexSocre += score
      });
      this.setState({
        payModalVisible: true,
        orderList: data,
        totalScore: indexSocre,
      });
    } else {
      console.log("openPayModal-----data", data);
      indexSocre = data.score;
      // indexSocre = score
      this.setState({
        payModalVisible: true,
        orderList: [data],
        totalScore: indexSocre,
      });
    }
  };

  render() {
    const columns = [
      {
        title: "文件名",
        dataIndex: "fileName",
        key: "fileName",
        align: "center",
      },
      // {
      //   title: "文件大小",
      //   dataIndex: "fileSize",
      //   key: "fileSize",
      //   align: "center",
      // },
      {
        title: "文件类型",
        dataIndex: "resourceType",
        key: "resourceType",
        align: "center",
      },
      {
        title: "操作",
        dataIndex: "操作",
        key: "操作",
        render: (_, record) => (
          <div className="NewsManage_Table_Text">
            <Button type="primary" onClick={() => this.handleDownLoad(record)}>
              <span>下载</span>
            </Button>
            <Button
              type="primary"
              danger
              style={{ marginLeft: "5px" }}
              onClick={() => this.handleRemove(record)}
            >
              <span>删除</span>
            </Button>
          </div>
        ),
      },
    ];

    const rowSelection = {
      selectedRowKeys: this.state.selectedRowKeys,
      onChange: this.onSelectChange,
    };
    return (
      <div className="Shopping_Page">
        <Header4 />
        <div className="Shopping_main">
          <div className="Shopping_Title">我的购物车</div>
          <div className="Shopping_Radio">
            <Radio.Group value={this.state.shopType} onChange={this.changeType}>
              <Radio value="base">基础数据</Radio>
              <Radio value="customized">地面数据定制</Radio>
            </Radio.Group>
            {this.state.selectedRowKeys.length > 0 &&
              this.state.shopType == "base" && (
                <span>
                  <Button
                    type="primary"
                    onClick={() => this.handleDownLoad(this.state.selectedRows)}
                  >
                    批量下载
                  </Button>
                  <Button
                    type="primary"
                    danger
                    style={{ marginLeft: ".3125rem" }}
                    onClick={() => this.handleRemoveAll(this.state.selectedRows)}
                  >
                    批量删除
                  </Button>
                </span>
              )}
          </div>
          {this.state.shopType == "base" ? (
            <div className="Shopping_Table">
              <Table
                className="IntegralManage_Table"
                dataSource={this.state.shopData}
                columns={columns}
                rowKey={"shopId"}
                loading={this.state.spinning}
                rowSelection={rowSelection}
                pagination={{
                  total: this.state.total,
                  showTotal: (total) => `共 ${total} 条`,
                }}
              ></Table>
            </div>
          ) : (
            <Iframe
              url={`https://landv.aircas.ac.cn:10088/OrderDownload/#/DownloadAuditList?token=${this.props.user.token}&show=2`}
            ></Iframe>
          )}
        </div>
        <PayModal
          payModalVisible={this.state.payModalVisible}
          closePayModal={() => this.setState({ payModalVisible: false })}
          orderList={this.state.orderList}
          totalScore={this.state.totalScore}
          updatecart={this.initShopData}
          init={this.initShopData}
          rules={{}}
        ></PayModal>
      </div>
    );
  }
}

const mapState = (state) => ({
  loginObj: state.userReducer.get("loginObj").toJS(),
  user: state.userReducer.get("user").toJS(),
});
const mapDispatch = (dispatch) => ({});

export default connect(mapState, mapDispatch)(Chronicles);
